import { FormControl, TextField } from '@mui/material';

interface JustificationFieldProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

function JustificationField({
  value,
  onChange,
  disabled = false,
}: JustificationFieldProps): React.JSX.Element {
  return (
    <FormControl fullWidth required>
      <TextField
        label='Justification'
        id='justification'
        value={value}
        onChange={(e) => onChange(e.target.value)}
        multiline
        minRows={4}
        fullWidth
        variant='outlined'
        disabled={disabled}
        slotProps={{ inputLabel: { shrink: value.length > 0 } }}
      />
    </FormControl>
  );
}

export default JustificationField;
